var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcWallet24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255,255,255,0)",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u21B3 \\u270F\\uFE0F Label",
    d: "M18.162 7.464H7.446a.8.8 0 0 0-.8.8.8.8 0 0 0 .8.8h10.716a.8.8 0 0 1 .8.8v6.976a.8.8 0 0 1-.8.8H6.375a1.341 1.341 0 0 1-1.34-1.336V7.196a1.341 1.341 0 0 1 1.34-1.34h12.322a.8.8 0 0 0 .8-.8.8.8 0 0 0-.8-.8H6.375a2.95 2.95 0 0 0-2.947 2.94v9.108a2.95 2.95 0 0 0 2.947 2.946h11.787a2.414 2.414 0 0 0 2.411-2.411V9.875a2.414 2.414 0 0 0-2.411-2.411Zm-.8 5.893a1.072 1.072 0 0 0-1.072-1.072 1.072 1.072 0 0 0-1.072 1.072 1.072 1.072 0 0 0 1.068 1.067 1.072 1.072 0 0 0 1.072-1.067Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWallet24);
export default __webpack_public_path__ + "static/media/ic_wallet_24.a19a67584c37269adc2f86c359666ede.svg";
export { ForwardRef as ReactComponent };